import type { CreateTask, LifeSpace } from '../db/models'
import type { TaskCreationData } from './types'

/** Wohin eine neue Aufgabe kommt — das weiß die Seite (oder die Schnelleingabe), nicht die Eingabe. */
export interface CreateTaskPlace {
  lifeSpace: LifeSpace
  projectId: string | null
  sectionId: string | null
  /** Fehlt sie, vergibt `createTask` den nächsten freien Platz. */
  order?: number
  /** Vorab vergeben, wenn die Liste die neue Zeile schon vor dem Schreiben kennen muss. */
  id?: string
}

/**
 * **Was in der Titelzeile getippt wurde → eine neue Aufgabe.**
 *
 * Stand bis 03.10.2026 sechsmal ausgeschrieben (Projekt, ⌘↵-Einschub, Demnächst, Wiederkehrend …),
 * und Demnächst hatte dabei die Checkliste vergessen. Eine Stelle für alle, damit kein Ort ein Feld
 * verliert. Abweichungen (Demnächst setzt den Tag der Gruppe, Wiederkehrend die Regel) legt der
 * Aufrufer darüber.
 */
export function toCreateTask(data: TaskCreationData, place: CreateTaskPlace): CreateTask & { id?: string } {
  return {
    ...(place.id !== undefined ? { id: place.id } : {}),
    title: data.title,
    description: data.description,
    status: 'todo',
    attention: data.attention ?? null,
    category: 'other',
    lifeSpace: place.lifeSpace,
    projectId: place.projectId,
    sectionId: place.sectionId,
    ...(place.order !== undefined ? { order: place.order } : {}),
    pausedAt: null,
    completedAt: null,
    parentTaskId: null,
    dueDate: data.dueDate ?? null,
    dueTime: data.dueTime ?? null,
    duePeriod: data.duePeriod ?? null,
    startDate: data.startDate ?? null,
    startTime: data.startTime ?? null,
    startPeriod: data.startPeriod ?? null,
    estimatedDuration: data.estimatedDuration ?? null,
    durationMode: data.durationMode ?? null,
    actualDuration: null,
    tags: data.tags ?? [],
    subtasks: data.subtasks,
    rewardId: data.rewardId ?? null,
    recurrence: data.recurrence ?? null,
  }
}
